import { CoreAccordion } from '@woolworthslimited/core-components-react/accordion';

import { FaqProps } from './faq-model';
import styles from './faq.module.scss';

export const Faq: React.FC<FaqProps> = ({
  heading,
  items,
  sectionId,
  onSelectionChange,
}) => {
  return (
    <div className={styles.faq} id={sectionId}>
      {heading && <h2 className={styles.heading}>{heading}</h2>}
      <CoreAccordion
        isTitleAccent
        items={items}
        onSelectionChange={onSelectionChange}
      />
    </div>
  );
};
